var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"k-card-goods",attrs:{"href":_vm.url}},[_c('div',{staticClass:"cover"},[_c('img',{attrs:{"src":_vm.goodsInfo.url}})]),_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.goodsInfo.name)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }